import Syncable from '@/syncing/Syncable.js'
import { useInstanceStore } from '@/store/backendInstances.js'
import { isInstanceNotStalePrecondition, isOnlinePrecondition } from '@/syncing/SyncablePreconditions.js'

class VersionSyncable extends Syncable {
  constructor(globalUniqueIdentifier) {
    super(globalUniqueIdentifier, 1000 * 60 * 60, [isOnlinePrecondition, isInstanceNotStalePrecondition])
  }

  hasInitialData() {
    return !!useInstanceStore().instances[this.globalUniqueIdentifier].version
  }

  async workload() {
    await useInstanceStore().loadVersion(this.globalUniqueIdentifier)
  }

  static getSyncableHandle() {
    return 'version'
  }
}

export default VersionSyncable
